import * as React from "react";
import { Icon } from '@fluentui/react';
import { getFileTypeIconProps } from '@fluentui/react-file-type-icons';
import {
    registerLocalFileTypeIcons,
    withLocalFileTypeIconFallback,
} from '../../../localFileTypeIcons';

registerLocalFileTypeIcons();

interface IFileIconProps {
    fileName: string;
    size?: number; // Optional size prop, default is 20
}

const FileIcon: React.FC<IFileIconProps> = ({ fileName, size = 20 }) => {
    const getFileTypeLabel = (name: string) => {
        const extension = name.includes('.') ? name.split('.').pop()?.toLowerCase() : undefined;

        if (!extension) {
            return 'Unknown file type';
        }

        const labels: { [key: string]: string } = {
            pdf: 'PDF document',
            doc: 'Word document',
            docx: 'Word document',
            xls: 'Excel spreadsheet',
            xlsx: 'Excel spreadsheet',
            ppt: 'PowerPoint presentation',
            pptx: 'PowerPoint presentation',
            txt: 'Text file',
            csv: 'CSV file',
            zip: 'ZIP archive',
            mp4: 'MP4 video',
            mp3: 'MP3 audio',
            jpg: 'JPEG image',
            jpeg: 'JPEG image',
            png: 'PNG image',
            gif: 'GIF image',
            svg: 'SVG image'
        };

        return labels[extension] || `${extension.toUpperCase()} file`;
    };

    const getFileIcon = (fileName: string) => {
        const extension = fileName.split(".").pop()?.toLowerCase();
        const iconProps = getFileTypeIconProps({ extension, size: size as any });
        return <Icon {...withLocalFileTypeIconFallback(iconProps)} />;
    };

    const fileTypeLabel = getFileTypeLabel(fileName);

    return (
        <span
            style={{ display: 'inline-flex', alignItems: 'center', lineHeight: 1 }}
            title={fileTypeLabel}
            aria-label={fileTypeLabel}
        >
            {getFileIcon(fileName)}
        </span>
    );
};

export default FileIcon;
